var _circle, _path, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCarouselNextIcon = function SvgCarouselNextIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "url(#paint0_linear_2_1856)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7594 23.4213C33.7591 23.421 33.7589 23.4207 33.7587 23.4205L29.4724 19.1691C29.1512 18.8506 28.6319 18.8518 28.3122 19.1719C27.9926 19.4919 27.9939 20.0096 28.315 20.3281L31.1928 23.1824H13.8203C13.3673 23.1824 13 23.5484 13 24C13 24.4515 13.3673 24.8176 13.8203 24.8176H31.1928L28.315 27.6719C27.9939 27.9904 27.9927 28.5081 28.3123 28.8281C28.6319 29.1482 29.1513 29.1493 29.4724 28.8309L33.7587 24.5795C33.7589 24.5792 33.7591 24.579 33.7594 24.5787C34.0807 24.2591 34.0797 23.7398 33.7594 23.4213Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1856",
    x1: 19.8281,
    y1: -113.71,
    x2: 105.027,
    y2: -4.78638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA57FF"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCarouselNextIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/carousel-next-icon.045abbd4.svg";
export { ForwardRef as ReactComponent };